export const CUSTOM_STATUS_INPUT = {
  PROCESSED: 'Processed',
  PROCESSING: 'Processing',
  PROCESSED_WITH_EXCEPTION: 'Processed With Exceptions',
  ISSUED: 'Issued',
  REJECTED: 'Rejected',
  FAILED: 'Failed',
}

export const CUSTOM_PURGED_STATUS_INPUT = {
  ACTIVE: 'Active',
  PURGED: 'Purged',
}

export const CUSTOM_ISSUED_CHECK_TYPE_INPUT = {
  SUBMITTED: 'Submitted',
  SINGLE: 'Single',
}

export const ERROR_STATUS_INPUT = {
  PROCESSED: 'PROCESSED',
  PROCESSING: 'PROCESSING',
  PROCESSED_WITH_EXCEPTION: 'PROCESSED_WITH_EXCEPTION',
  ISSUED: 'ISSUED',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
  FAIL: 'FAIL',
}

export const settingsIssuedCheck = [
  {
    propertyName: 'clientName',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'accountName',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'fileMappingFormat',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'status',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'items',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'amount',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'inputDate',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'fileName',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'checkNumber',
    isSelect: true,
    defaultSelect: true,
  },
  {
    propertyName: 'user',
    isSelect: false,
    defaultSelect: false,
  },
]

export const settingsIssuedDetail = [
  {
    propertyName: 'fileName',
    isSelect: true,
    defaultSelect: true,
    width: 190,
    minWidth: 190,
    maxWidth: 190,
  },
  {
    propertyName: 'inputDate',
    isSelect: true,
    defaultSelect: true,
    width: 140,
    minWidth: 140,
    maxWidth: 140,
  },
  {
    propertyName: 'status',
    isSelect: true,
    defaultSelect: true,
    width: 152,
    minWidth: 152,
    maxWidth: 152,
  },
  {
    propertyName: 'processedItems',
    isSelect: true,
    defaultSelect: true,
    minWidth: 96,
    maxWidth: 96,
  },
  {
    propertyName: 'rejectedItems',
    isSelect: true,
    defaultSelect: true,
    minWidth: 96,
    maxWidth: 96,
  },
  {
    propertyName: 'amount',
    isSelect: true,
    defaultSelect: true,
    minWidth: 100,
    maxWidth: 100,
  },
]
